import { useQuery } from '@tanstack/react-query';
import type { TDMTypes } from '@tf/api';
import { TDMClient } from '@tf/api';
import constate from 'constate';
import type React from 'react';

import { useOriginTenantSlug } from '@/core/providers/OriginTenantSlugProvider';
import { QueryLoader } from '@/core/providers/QueryLoader';

const [OriginTenantSettingsStateProvider, useOriginTenantSettingsState] = constate(
	(props: { value: TDMTypes.GetClientAreaSettingsByTenantData }) => {
		return props.value;
	},
);

export const useOriginTenantSettings = useOriginTenantSettingsState;

export const OriginTenantSettingsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const originTenantSlug = useOriginTenantSlug();

	const settingsQuery = useQuery({
		queryKey: ['originTenantSettings'],
		queryFn: async (): Promise<TDMTypes.GetClientAreaSettingsByTenantData> => {
			const res = await TDMClient.getInstance().getClientAreaSettingsByTenant({ tenant: originTenantSlug });
			return res.json();
		},
	});

	return (
		<QueryLoader
			query={settingsQuery}
			errorMessage="Failed to load settings"
			renderData={(data) => {
				return <OriginTenantSettingsStateProvider value={data}>{children}</OriginTenantSettingsStateProvider>;
			}}
		/>
	);
};
